import { TRACKING_PAGE_ELEMENT_ID } from '../../config/shopware66';

export interface InjectedTrackingPage {
  type: string;
  pageData?: { product_id: string; variant_id: string | null; price: number };
}

/**
 * Read Twig-injected JSON from the tracking script element (PDP).
 */
export function readInjectedTrackingPage(): InjectedTrackingPage | null {
  const el = document.getElementById(TRACKING_PAGE_ELEMENT_ID);
  if (!el) {
    return null;
  }
  const txt = (el.textContent ?? '').trim();
  if (!txt) {
    return null;
  }

  try {
    return JSON.parse(txt) as InjectedTrackingPage;
  } catch {
    return null;
  }
}
